var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceZeros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7508 32.2627L28.8713 35.1422C28.2634 35.7501 27.3996 36.022 26.3438 36.022C22.8885 36.022 17.3375 32.9506 12.2665 27.9276L12.2025 27.8636C12.2025 27.8636 12.1545 27.8156 12.1385 27.7996C5.57974 21.1769 2.34835 13.7703 4.92386 11.1947L7.78732 8.31529C8.63516 7.48345 9.9949 7.48345 10.8267 8.31529L14.0101 11.4987C14.858 12.3465 14.858 13.7063 14.0101 14.5381L11.6746 16.8737C10.6828 17.8655 12.4744 21.2248 15.6578 24.4082C18.8412 27.5916 22.2006 29.3673 23.1924 28.3915L25.528 26.0559C26.3598 25.2081 27.7195 25.2081 28.5514 26.0559L31.7508 29.2393C32.5826 30.0712 32.5826 31.4309 31.7508 32.2627Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 23.2617C27.5143 23.2617 30.3125 20.4635 30.3125 17.0117C30.3125 13.5599 27.5143 10.7617 24.0625 10.7617C20.6107 10.7617 17.8125 13.5599 17.8125 17.0117C17.8125 20.4635 20.6107 23.2617 24.0625 23.2617Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.619 21.5784L28.506 12.6914",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceZeros);
export default __webpack_public_path__ + "static/media/serviceZeros.d04e2ed713021f992a912f16042ad0c1.svg";
export { ForwardRef as ReactComponent };